export default "__VITE_ASSET__uoE7mYqk__"